import React from 'react'
import { ShowFilterButtonProps } from './ShowFilterButton.types'
import styles from './ShowFilterButton.module.scss'
import cl from 'classnames'
import { Button, Checkbox, Text1 } from 'components/shared'

const ShowFilterButtonComponent = (props: ShowFilterButtonProps) => {
  const {
    isChecked,
    checkboxProps,
    className,
    ...rest
  } = props

  return (
    <Button
      preset='icon'
      className={cl(styles.container, className)}
      {...rest}
    >
      <Checkbox isChecked={isChecked} {...checkboxProps} />
      <Text1 overflowEllipsis>Show</Text1>
    </Button>
  )
}

const ShowFilterButton = ShowFilterButtonComponent
export { ShowFilterButton }
